var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrugActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEE8FA"
    },
    d: "M352.182,368.614l-83.467,83.467c-57.656,57.656-151.136,57.656-208.794-0.002 C2.266,394.424,2.264,300.941,59.92,243.286l83.467-83.467L352.182,368.614z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59A3CF"
    },
    d: "M164.32,511.064c-43.641,0-84.668-16.994-115.527-47.853 c-63.703-63.704-63.703-167.354-0.003-231.055l83.469-83.467c6.146-6.145,16.113-6.145,22.259,0l208.795,208.795 c2.951,2.951,4.61,6.955,4.61,11.129s-1.659,8.178-4.61,11.129l-83.467,83.467C248.985,494.068,207.96,511.064,164.32,511.064z  M143.387,182.079l-72.338,72.338c-51.426,51.426-51.426,135.106,0.002,186.535c24.913,24.913,58.037,38.633,93.268,38.633 s68.354-13.72,93.265-38.633l72.338-72.336L143.387,182.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59A3CF"
    },
    d: "M163.382,512C163.38,512,163.384,512,163.382,512c-43.641,0-84.668-16.994-115.527-47.853 C16.996,433.289,0.001,392.261,0.001,348.62s16.992-84.668,47.85-115.526L233.169,47.776c63.7-63.701,167.35-63.701,231.053,0 c63.701,63.703,63.701,167.353,0,231.054l-47.014,47.014c-6.146,6.146-16.114,6.146-22.259,0c-6.146-6.146-6.146-16.113,0-22.259 l47.013-47.014c24.913-24.913,38.633-58.035,38.633-93.267s-13.72-68.354-38.633-93.267c-51.428-51.428-135.106-51.428-186.536,0 L70.106,255.356c-51.426,51.428-51.426,135.106,0.002,186.535c51.428,51.428,135.109,51.428,186.533,0 c6.146-6.146,16.113-6.146,22.261,0c6.146,6.146,6.146,16.113,0,22.261C248.051,495.004,207.02,512,163.382,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59A3CF"
    },
    d: "M122.101,306.42c-4.028,0-8.057-1.536-11.129-4.61c-6.146-6.146-6.146-16.113,0-22.261 l168.656-168.656c6.146-6.146,16.113-6.146,22.261,0c6.148,6.146,6.146,16.113,0,22.261L133.23,301.81 C130.156,304.884,126.128,306.42,122.101,306.42z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugActive);
export default __webpack_public_path__ + "static/media/drug-active.42842167c08db05264ee94b5b611dae9.svg";
export { ForwardRef as ReactComponent };